export const environment = {
  production: false,
  urlBase: 'https://inscripcion-servicios.duoc.cl',
  urlPagosOnline : 'https://www2.duoc.cl/botonpago/boton_pago.php',
  urlAyuda: 'https://www.duoc.cl/oferta-academica/cursos-diplomados/preguntas-frecuentes-2/',
  recaptcha: {
    siteKey: '6LdhlgwjAAAAAEQ04X16BTu2VuxHpzloRJPmbJ6e'
  }
}
